import {connect, Field} from 'formik';
import {Trans} from 'react-i18next';
import classnames from 'classnames';
import RadioButton from '../../../../../components/formik/RadioButton';
import React from 'react';

export default connect(function CreateAccountForm({width}) {
  return (
    <>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.common.create.account.form">
          Create Account Form
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <p className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.common.create.account.form.desc">
          Select whether the following fields should be optional or required in
          the Create Account form for new customers.
        </Trans>
      </p>
      <div className="row" style={{alignItems: 'center'}}>
        <label className="col-3 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.common.first.name">
            First Name
          </Trans>
        </label>
        <div
          className="col-9 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-6': width >= 1366,
              'col-12': width < 1366,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={'createForm.firstName'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.required">
                  Required
                </Trans>
              }
              value={'required'}
              component={RadioButton}
            />
          </div>
        </div>
      </div>
      <div className=" row" style={{alignItems: 'center'}}>
        <label className="col-3 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.common.last.name">
            Last Name
          </Trans>
        </label>
        <div
          className="col-9 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-6': width >= 1366,
              'col-12': width < 1366,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={'createForm.lastName'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.required">
                  Required
                </Trans>
              }
              value={'required'}
              component={RadioButton}
            />
          </div>
        </div>
      </div>
      <div className=" row" style={{alignItems: 'center'}}>
        <label className="col-3 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.common.date.of.birth">
            Date of Birth
          </Trans>
        </label>
        <div
          className="col-9 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-6': width >= 1366,
              'col-12': width < 1366,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={'createForm.dateOfBirth'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.required">
                  Required
                </Trans>
              }
              value={'required'}
              component={RadioButton}
            />
          </div>
        </div>
      </div>
      <div className=" row" style={{alignItems: 'center'}}>
        <label className="col-3 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.common.email">Email</Trans>
        </label>
        <div
          className="col-9 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-12': true,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={'createForm.email'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.required">
                  Required
                </Trans>
              }
              value={'required'}
              component={RadioButton}
              style={{marginRight: '20px'}}
            />
            <Field
              name={'createForm.email'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.optional">
                  Optional
                </Trans>
              }
              value={'optional'}
              component={RadioButton}
            />
          </div>
        </div>
      </div>
      <div className=" row" style={{alignItems: 'center'}}>
        <label className="col-3 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.common.phone.number">
            Phone Number
          </Trans>
        </label>
        <div
          className="col-9 col-lg-8 col-md-8 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-12': true,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={'createForm.phone'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.required">
                  Required
                </Trans>
              }
              value={'required'}
              component={RadioButton}
              style={{marginRight: '20px'}}
            />
            <Field
              name={'createForm.phone'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.optional">
                  Optional
                </Trans>
              }
              value={'optional'}
              component={RadioButton}
            />
          </div>
        </div>
      </div>
      <div className=" row" style={{alignItems: 'center'}}>
        <label className="col-3 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.common.gender">Gender</Trans>
        </label>
        <div
          className="col-9 row"
          style={{display: width >= 1366 ? 'flex' : 'block'}}
        >
          <div
            className={classnames({
              'col-12': true,
              'kt-margin-b-10': width < 1366,
            })}
          >
            <Field
              name={'createForm.gender'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.required">
                  Required
                </Trans>
              }
              value={'required'}
              component={RadioButton}
              style={{marginRight: '20px'}}
            />
            <Field
              name={'createForm.gender'}
              label={
                <Trans i18nKey="p.s.uiconfiguration.common.optional">
                  Optional
                </Trans>
              }
              value={'optional'}
              component={RadioButton}
            />
          </div>
        </div>
      </div>
    </>
  );
});
